import '../styles.css';
import { bootstrap } from '@boots-edu/webz';

import { MainComponent } from '../src/app/main.component';
bootstrap<MainComponent>(MainComponent);
